module.exports = __webpack_public_path__ + "static/img/live_tu33.f9b71b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/live_tu33.png
// module id = oOia
// module chunks = 1